import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from './Title.styles';
import { useClassName } from '../../../uiClassNames';

var Title = function Title(_ref) {
  var text = _ref.text;
  var textClassName = useClassName('title');
  return _jsx(Text, Object.assign({
    className: textClassName
  }, {
    children: text
  }));
};

export default Title;